// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {Fragment} from 'react';
import {Link} from 'react-router-dom';
import cn from 'classnames';
import {Faq, i_faq_props} from '../common/faq';
import styles from './faq.module.less';
import {useLocation} from 'react-router';
import {use_data_provider} from '../../../../hola/pub/lib/use_data_provider';
import {Input} from '../../../../hola/pub/lib/input';
import {Textarea} from '../../../../hola/pub/lib/textarea';
import {Button} from '../../../../shared/button';
import {get_aliased_pathname} from '../../../../hola/pub/lib/use_pathname';
const test_guide_url = 'https://support.oculusproxies.com/hc/en-us/articles'
    +'/23101526359835-Integrate-your-proxies-into-any-browser';

export const get_hp_faq_client = theme=>[
    {
        quest: 'Why do I need proxies?',
        ans: <p className={cn(theme.p14, theme.med)}>
          Proxies are a necessity for any bot or tool when scraping
          or trying to purchase something from a website. Proxies
          allow you to run more tasks, decrease the odds of being
          banned, and have a faster connection to most websites.
        </p>,
    },
    {
        quest: 'What is an ISP Proxy?',
        ans: <p className={cn(theme.p14, theme.med)}>
          This is the highest quality Residential proxies leased from
          Internet Service Providers (ISP) in various countries that
          you can purchase. This plan works great on eCommerce
          websites with bot protection such as Shoppy, Walmart,
          Target, Best Buy, Amazon, and more.
        </p>,
    },
    {
        quest: 'What is a ISP Premium Proxy?',
        ans: <p className={cn(theme.p14, theme.med)}>
          This is the highest quality Residential proxies leased from
          US Internet Service Providers (ISP). This plan works great
          on Google related and key social media websites allowing
          for unblocked access from US Residential IP addresses.
        </p>,
    },
    {
        quest: 'What is an Datacenter Proxy?',
        ans: <p className={cn(theme.p14, theme.med)}>
          Oculus Data Center Proxies is a shared DC plan which comes
          at a very affordable cost. This product's main purpose is
          for web scraping.
        </p>,
    },
    {
        quest: 'Is there a Free Plan?',
        ans: <Fragment>
          <p className={cn(theme.p14, theme.med)}>
            Yes, after signup you can get a free package of 5
            Datacenter IP's with 100MB bandwidth, this plan is
            valid for 7 days.
          </p>
          <p className={cn(theme.p14, theme.med)}>
            You can activate the free plan, from the datacenter
            product page or <Link to="/pricing">pricing page</Link>
          </p>
        </Fragment>,
    },
    {
        quest: 'How do you price your proxies?',
        ans: <p className={cn(theme.p14, theme.med)}>
          Oculus pricing model is very straightforward. We have only
          prepaid, flat rate plans with no hidden costs.
          <br/>
          Shared proxies, whether datacenter (DC) or ISP are priced
          by the volume of data you'll send via the proxies, measured
          in gigabytes (GB). You can select the plan according to the
          amount of GB you expect to use. The price is usually the
          same per GB in the various plans with some discount on the
          larger packages. Packages are valid for 3 months from the
          time of purchase
          <br/>
          Dedicated proxies Datacenter or ISP Premium are allocated
          exclusively for your use, priced by the number of proxies (
          $/proxy)
          <br/>
          Dedicated proxy pairs will be allocated to you for 1 month,
          and you can select package according to the number of
          proxies you'll need. Price is typically the the same per
          proxy with some discount on the larger packages.
        </p>,
    },
    {
        quest: 'What proxy protocols are supported?',
        ans: <p className={cn(theme.p14, theme.med)}>
          HTTP, HTTPS, and SOCKS5 proxy connection protocols.
        </p>,
    },
    {
        quest: 'Can I test my proxies?',
        ans: <p className={cn(theme.p14, theme.med)}>
          Sure! Check out our free proxy testing tool guide{' '}
          <a href={test_guide_url}>here</a>
        </p>,
    },
    {
        quest: 'Where can I get proxies for Events?',
        ans: <p className={cn(theme.p14, theme.med)}>
          We provide dedicated Events Proxies optimized for this use
          case, These proxies can be purchased and managed on our
          legacy website, https://oculusproxies.com/legacy
        </p>,
    },
    {
        quest: 'How does auto-renewal work?',
        ans: <p className={cn(theme.p14, theme.med)}>
          When auto renewal is enabled for a plan, once usage will
          reach 90% of the plan or it will be 5 days before the plan
          expiration, we'll automatically generate new plan. The
          remaining GB or time that were not used will be added to
          the new plan so nothing is lost
        </p>,
    },
    {
        quest: 'Can I purchase dedicated datacenter from different '
            +'countries?',
        ans: <p className={cn(theme.p14, theme.med)}>
          Yes, we provide dedicated DC proxies from many countries,
          for each plan you purchase you can select one country for
          the purchased IP's. If you need additional country, you can
          purchase additional plan.
        </p>,
    },
    {
        quest: 'Which proxy type is best for me?',
        ans: <p className={cn(theme.p14, theme.med)}>
          Oculus offers several types of proxies and although all provide
          fast and effective access to the internet from the desired
          locations, each type has its own advantages and the use
          cases it best fits.
          <br/> <br/>
          <b>Datacenter (DC)</b>
          <br/>
          These proxies are provided through our datacenter servers
          around the world and provide the fastest and most cost
          effective option. Datacenter proxies are most suitable for
          accessing websites that are not using advanced blocking
          methods.
          <br/>
          Typical use cases: eCommerce, social media profiles,
          general purpose data scraping from various websites.
          <br/>
          We Offer Datacenter proxies in two different plans:
          <br/>
          Shared Datacenter is a pool of proxies that your requests
          are channelled through them together with other users'
          requests. This is the most cost effective option offered at
          very affordable prices in different Bandwidth packages
          Dedicated Datacenter proxies are allocated exclusively to
          you and you will be the only one using them for the entire
          plan duration. This allows you to fully control which
          websites are accessed from these proxies, keeping them
          "clean" from any unwanted interferences.
          <br/>
          <br/>
          <b>ISP - Internet Service Providers</b>
          <br/>
          Pool of IP's leased from leading ISP providers around the
          world that are classified as residential IP's, allowing you
          to access websites as an individual living in the target
          location while still enjoying high speed connectivity and
          data collection.
          <br/>
          ISP proxies are best suitable for accessing hard to reach
          websites while maintaining a real user behaviour. ISP
          allows access to websites that may be blocked when using
          Datacenter proxies.
          <br/>
          Typical use cases: data and price scraping, performing,
          geolocation based actions and more
          <br/>
          <br/>
          <b>ISP Premium</b>
          <br/>
          These proxies are from a US based pool of ISP IP's and are
          designed to provide smooth access to Google search engine
          and various social media websites that may be blocked for
          regular ISP proxies.
          <br/>
          We provide ISP Premium Proxies as unshared (dedicated) so
          you can select which websites they will access and prevent
          unwanted influence that may be caused by other users using
          these IP's in parallel.
          <br/>
          Typical use cases: Google search, google related websites,
          social media accounts, eCommerce, Events or business
          related websites you'd like to access from a US bases
          location. These IP addresses remain static and the same
          throughout the duration of the plan.
        </p>,
    },
    {
      quest: 'Can I use Oculus proxies for SMTP checks?',
      ans: <p className={cn(theme.p14, theme.med)}>
        No, SMTP and email-related activities, including email verification
        via SMTP checks, are not approved use cases for Oculus proxies.
        Our residential proxies are configured to restrict common SMTP ports,
        including port 25, to maintain security and prevent misuse.
      </p>
    }
];

type t_hp_faq_props = Partial<i_faq_props> & {
  custom_questions?: Array<{quest: string, ans: string}>;
  country?: string;
};
export const HP_faq = (props: t_hp_faq_props)=>{
  const {title, get_questions, custom_questions} = props;
  const {pathname: current_pathname} = useLocation();
  const pathname = get_aliased_pathname(current_pathname);
  const get_data_id =()=>`schema-faqs-${pathname}`;
  const {data} = use_data_provider(get_data_id);
  const get_hp_faq = theme=>
    (custom_questions || data?.result?.data || [])?.map(item=>({
      quest: item.quest,
      ans: typeof item.ans === 'string'
        ? <div className={cn(theme.p14, theme.med)}
          dangerouslySetInnerHTML={{__html: item.ans}}/>
        : item.ans
    }));
  return (
    <div className={cn(styles.faq)}>
      <div className={styles.container}>
        <Faq
          title={title}
          get_questions={data?.result
            ? get_hp_faq : get_questions || get_hp_faq_client}
          questions_shown={6}
        />
      </div>
    </div>
  );
};

interface i_hp_faq_editor_props {
  value: {
    title?: string;
    custom_questions?: Array<{quest: string, ans: string}>;
  };
  on_change: (v: i_hp_faq_editor_props['value']) => void;
}

export const HP_faq_editor = (props: i_hp_faq_editor_props)=>{
  const {value, on_change} = props;
  const questions = value.custom_questions || [];

  const update_question = (
    index: number,
    key: 'quest' | 'ans',
    new_val: string)=>
    {
    const updated = [...questions];
    updated[index] = {...updated[index], [key]: new_val};
    on_change({...value, custom_questions: updated});
  };

  const add_question = ()=>{
    const updated = [...questions, {quest: '', ans: ''}];
    on_change({...value, custom_questions: updated});
  };

  const remove_question = (index: number)=>{
    const updated = questions.filter((_, i)=>i!==index);
    on_change({...value, custom_questions: updated});
  };

  return <div>
    <Input
      value={value.title || ''}
      on_change={v=>on_change({...value, title: v})}
      label='Section Title'
    />
    {questions.map((q, i)=>
      <div key={i} style={{border: '1px solid #ccc', padding: '8px',
        marginBottom: '8px'}}>
        <Input
          value={q.quest}
          on_change={v=>update_question(i, 'quest', v)}
          label={`Question ${i+1}`}
        />
        <Textarea
          value={q.ans}
          on_change={v=>update_question(i, 'ans', v)}
          placeholder={`Answer ${i+1}`}
        />
        <Button caption='Remove' on_click={()=>remove_question(i)}
          color='light_red' round={false}/>
      </div>
    )}
    <Button caption='Add Question' on_click={add_question}
      color='blue' round={false}/>
  </div>;
};
